// libs
import React, { memo, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

//components
import MobileCart from './components/MobileCart';
import AuthModalWrapper from 'shared/components/AuthModal/AuthModalWrapper';

// constants
import { HOME_CART_URL } from 'shared/constants/uri';
import { EDD_AB_EXPERIMENT } from 'shared/components/EstimatedDeliveryDetails/constants';

// helpers
import { getDeviceType } from 'shared/helpers/app';
import { setStorageEddVariant } from './helpers';
import { getExperimentVariant } from '@nykaa/experiment-sdk/client';

function Cart() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const canShowMwebCart = getDeviceType() === 'MSITE' || searchParams.get('platform') === 'desktop';
  const { isEligible: isEligibleForEDD } = getExperimentVariant(EDD_AB_EXPERIMENT);

  useEffect(() => {
    setStorageEddVariant(!isEligibleForEDD);
  }, [isEligibleForEDD]);

  if (canShowMwebCart) {
    return (
      <AuthModalWrapper>
        <MobileCart />
      </AuthModalWrapper>
    );
  }

  return <Redirect to={HOME_CART_URL} />;
}

export default memo(Cart);
